import Brand from '../helpers/Brand';
import Popup from '../helpers/Popup';
import Form from '../helpers/Form';
import Loader from '../helpers/Loader';

;$(function() {
	$('[name="phone"]').attr('type', 'tel');
	$('[name="phone"]').inputmask('+7 (999) 999-99-99');

	$('[data-load-models] select[name="brand"]').change(function() {

		Brand.loadModels($(this).val()).then(models => {

			var options = [];
			options.push(new Option('Модель вашего авто', '', true, true));

			for (let i in models)
				options.push(new Option(models[i].name, models[i].id, false, false));

			$('[data-load-models] select[name="model"]').html(options).trigger('change');
		});

	});

	$('[name="company_type"]').change(function() {
		if (this.value == 1) {
			$('[name="company_name"]').removeAttr('required');
			$('[name="inn"]').removeAttr('required');
		} else {
			$('[name="company_name"]').attr('required', '');
			$('[name="inn"]').attr('required', '');
		}	
	});

	$('.form-popup').find('[type="submit"]').click(function(e) {
		e.preventDefault();
		var form = new Form($(this).parents('form').eq(0));

		if ((form.getValues().action == 'change-avatar') || (form.getValues().action == 'verify-sms'))
			return;

		var loader = new Loader(form.form);

		if (! form.isValid()) {
			for (let name in form.errors) {
				form.showError(name, form.errors[name]);
			}

			loader.stop();
			return;
		}

        if ((form.getValues().action == 'mail.feedback' || form.getValues().action == 'register') && ! form.getValues()['g-recaptcha-response'] && window.location.host == 'molotok.rolf-probeg.ru') {
            loader.stop();
            Popup.error('Подвердите капчу.');
            return false;
        }


		form.send(
			r => {
				if (r.STATUS == 'ERROR') {
					loader.stop();
					$('#popup-error').find('.msg').text(r.MESSAGE);
					Popup.show('#popup-error', form.form);
				} else if (r.STATUS == 'OK') {
					if (form.getValues().action == 'register') {
						loader.stop();
						window.bf_id = r.BF_ID;
						$('#verify-phone').text(form.getValues().phone);
						$('#verify-phone').append('<input type="hidden" name="bf_id" value="' + r.BF_ID + '">');
						Popup.show('#popup-verify-sms', form.form);
					}
					else if (r.MESSAGE != undefined) {
						loader.stop();
						$('#popup-success').find('.msg').text(r.MESSAGE);
						Popup.show('#popup-success', form.form);
					}
					else {
						window.location.href = window.location.href;
					}
				}
			},
			e => {
				loader.stop();
				var r = e.responseJSON;

				if (r.MESSAGE != undefined) {
					loader.stop();
					$('#popup-error').find('.msg').text(r.MESSAGE);
					Popup.show('#popup-error', form.form);
				} else if (r.errors != undefined) {
					for (let name in r.errors) {
						if (r.errors[name][0] == 'These credentials do not match our records.')
							r.errors[name][0] = 'Логин или пароль указаны неверно.';

						form.showError(name, r.errors[name][0]);
					}
				}
			}
		);
	});

	$(document).on('click','#resend-sms', function (e) {
		e.preventDefault();

		function showRespose(msg, isErr) {
			isErr = isErr || false;

			$('#resend-sms').parent().hide();
			var form = $('#resend-sms').parents('form').eq(0);
			if (form.find('.form__footnote').length == 1)
				form.find('.form__footnote').after('<div class="form__footnote' + (isErr ? ' error' : '') + '" id="resend-sms__msg"></div>');
			$('#resend-sms__msg').html(msg);
			$('#resend-sms__msg').show();
			setTimeout(function() {
				$('#resend-sms__msg').hide();
				$('#resend-sms').parent().show();
			}, 60000);
		}

		$.ajax({
			type: 'POST',
			url: '/api/form/resend-sms',
			data: {bf_id: window.bf_id},
			success: r => {
				showRespose(r.MESSAGE, r.STATUS != 'OK');
			},
			error: e => {
				var r = e.responseJSON;
				if (r != undefined) {
					showRespose(r.MESSAGE, true);
				}
			}
		})
	});

    $('#popup-verify-sms').find('[type="submit"]').click(function(e) {
        e.preventDefault();

        var form = new Form($(this).parents('form').eq(0));
        var loader = new Loader(form.form);

        if (! form.isValid()) {
            for (let name in form.errors) {
                form.showError(name, form.errors[name]);
            }

            loader.stop();
            return;
        }

        form.send(
            r => {
                if (r.STATUS == 'ERROR') {
                    loader.stop();
                    form.showError('code', r.MESSAGE);
                } else if (r.STATUS == 'OK') {

                    if (r.MESSAGE != undefined) {
                        loader.stop();
                        form.showError('code', r.MESSAGE);
                    }
                    else {
                        window.location.href = '/';
                    }
                }
            },
            e => {
                loader.stop();
                var r = e.responseJSON;
                if (r.MESSAGE != undefined) {
                    loader.stop();
                    form.showError('code', r.MESSAGE);
                } else if (r.errors != undefined) {
                    for (let name in r.errors)
                        form.showError(name, r.errors[name][0]);
                }
            }
        );
    });


	$('#verify-phone').find('[type="submit"]').click(function(e) {
		e.preventDefault();
		var form = new Form($(this).parents('form').eq(0));
		var loader = new Loader(form.form);

		if (! form.isValid()) {
			for (let name in form.errors) {
				form.showError(name, form.errors[name]);
			}

			loader.stop();
			return;
		}

		form.send(
			r => {
				if (r.STATUS == 'ERROR') {
					loader.stop();
					form.showError('code', r.MESSAGE);
				} else if (r.STATUS == 'OK') {
					if (r.MESSAGE != undefined) {
						loader.stop();
                        form.showError('code', r.MESSAGE);
					}
					else {
						window.location.href = '/';
					}
				}
			},
			e => {
				loader.stop();
				var r = e.responseJSON;

				if (r.MESSAGE != undefined) {
					loader.stop();
                    form.showError('code', r.MESSAGE);
				} else if (r.errors != undefined) {
					for (let name in r.errors)
						form.showError(name, r.errors[name][0]);
				}
			}
		);
	});

	/* Форма регистрции */
	$('form.form input[name="company_type"]').change(function() {
		let form = $(this).parents('.form').eq(0);

		if ($(this).val() == 1) {
			form.find('[name="company_name"]').slideUp();
			form.find('[name="inn"]').slideUp();
		} else {
			form.find('[name="company_name"]').slideDown();
			form.find('[name="inn"]').slideDown();
		}
	});

	if (typeof $.kladr != 'undefined') {
		$('[name="city"]').kladr({
			type: $.kladr.type.city,
			verify: true,
			openBefore: () => {
				$('[name="city"]').attr('autocomplete', 'false');
			}
		});
	}
});